import {
  TableSortLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";

const heads = [
  { name: "name", displayName: "Player" },
  { name: "count", displayName: "Amount Owned" },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1.5),
  textAlign: "center",
  fontSize: "0.9rem",
  fontFamily: "Minecraft Seven",
  color: "#FFFFFF",
  backgroundColor: "#333",
  borderBottom: "1px solid #444",
}));

const StyledTableHeaderCell = styled(StyledTableCell)(({ theme }) => ({
  backgroundColor: "#48494a",
  color: "#F5F5F5",
  borderBottom: "4px solid #000000",
  width: "50%",
  boxShadow: `        
        inset 2px 0 0 0 #000000,
        inset -2px 0 0 0 #000000,
        inset 0 4px 0 0 #6d6d6e,
        inset -6px 0 0 0 #6d6d6e,         
        inset 6px 0 0 0 #5a5b5c,
        inset 0 -4px 0 0 #5a5b5c 
    `,
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  overflow: "hidden",
  backgroundColor: "#1F1F1F",
  border: "4px solid #000000",
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 500,
  backgroundColor: "#252525",
}));

const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
  backgroundColor: "#48494a",
  color: "#E0E0E0",
  boxShadow: "inset 0 4px 0 0 #5a5b5c",
  "& .MuiSelect-icon": {
    color: "#F5F5F5",
  },
}));

export default function CosmeticOwnerTable({ owners }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState();
  const [orderAsc, setOrderAsc] = useState();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSort = (event, name) => {
    event.preventDefault();
    setOrderAsc(orderBy === name ? !orderAsc : true);
    setOrderBy(name);
  };

  return (
    <StyledPaper>
      <StyledTableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {heads.map((col, idx) => (
                <StyledTableHeaderCell
                  key={col.name}
                  sortDirection={
                    orderBy === col.name ? (orderAsc ? "asc" : "desc") : false
                  }
                >
                  <TableSortLabel
                    active={orderBy === col.name}
                    direction={
                      orderBy === col.name ? (orderAsc ? "asc" : "desc") : "asc"
                    }
                    onClick={(event) => handleSort(event, col.name)}
                    hideSortIcon
                    sx={{
                      color: "#F5F5F5",
                      "&.MuiTableSortLabel-root": {
                        color: "#F5F5F5",
                      },
                      "&.MuiTableSortLabel-root.Mui-active": {
                        color: "#F5F5F5",
                      },
                      "& .MuiTableSortLabel-icon": {
                        color: "#F5F5F5 !important",
                      },
                      "& .MuiTableSortLabel-iconDirectionDesc": {
                        color: "#F5F5F5 !important",
                      },
                      "& .MuiTableSortLabel-iconDirectionAsc": {
                        color: "#F5F5F5 !important",
                      },
                    }}
                  >
                    {col.displayName}
                  </TableSortLabel>
                </StyledTableHeaderCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {owners
              .sort((a, b) => {
                var greater = 0;
                if (a[orderBy] < b[orderBy]) greater = -1;
                else if (a[orderBy] > b[orderBy]) greater = 1;
                return orderAsc ? greater : -greater;
              })
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, idx) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                    <StyledTableCell>{item.name}</StyledTableCell>
                    <StyledTableCell>{item.count}</StyledTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </StyledTableContainer>
      <StyledTablePagination
        rowsPerPageOptions={[10, 25, 100, 500]}
        component="div"
        count={owners.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </StyledPaper>
  );
}
